import moment from "moment-timezone";
// import store from "@/store";

export function formatDate(time,segmentation,id) {
        let date = new Date(time);
        var y = date.getFullYear();
        let ms1 = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let m1 = date.getMinutes();
        // let s = date.getSeconds();
        let m11 = m1 < 10 ? '0'+m1 : m1;
        let monthEnglish = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let Month = monthEnglish[new Date(date).getMonth()];
        let today = `${y}/${ms1}/${d}`; 
        let todayTime = new Date(today).getTime(); // 当天凌晨的时间
        let yesterdayTime = new Date(todayTime - 24 * 60 * 60 * 1000).getTime(); // 昨天凌晨的时间
        let isFullTear = new Date().getFullYear();
        // let arr = [];
        //间隔时间
        if(segmentation === 'date') {
            return {date:`${Month} ${d}, ${y}`,idtimes:id}  
        }
        //今天
        if (new Date().getTime() - new Date(date).getTime() < 86400000) {
          if(h < 13) {
            return `${h}:${m11} AM`
          } else {
            return `${h - 12}:${m11} PM`
          }
        }
        //昨天
        if (time < todayTime && yesterdayTime <= time) {
            return 'Yesterday'
        }
        //是否是今年
        if (isFullTear === y) {
            return `${Month} ${d}`
        } else {
            return `${Month}${d} ${y}`
        }
        
}

export function formatDateTime(dateInfo = Date.now(),format = "MMM DD, YYYY, HH:mm z") {
    return moment(dateInfo).format(format);
}
